import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { onFetchEntertainmentProducts } from './action';

export default function Index() {
  const dispatch = useDispatch();
  const products = useSelector((state) => state.EntertainmentProducts.allData)

  useEffect(() => {
    if (!products.length > 0) {
      dispatch(onFetchEntertainmentProducts());
    }
  }, [dispatch, products.length]);
}